import {
    IAxisLabelRenderEventArgs,
    ITextRenderEventArgs,
    ITooltipRenderEventArgs
} from '@syncfusion/ej2-angular-charts';

import { DatePipe, DecimalPipe } from '@angular/common';
import { SalesDisplayMode } from '../enums/sales.display.mode';
import { formatCurrencyAbbreviated } from "./util";

const decimalPipe = new DecimalPipe('en-ZA');
const datePipe = new DatePipe('en-ZA');

function onTextRender(args: ITextRenderEventArgs): void {
    if (args.text) {
        const rawValue = parseFloat(args.text.replace(/[^\d.]/g, ''));
        args.text = formatCurrencyAbbreviated(rawValue);
    }
}

function onAccumulationChartTextRender(args: ITextRenderEventArgs): void {
    if (typeof args.point?.y === 'number') {
        args.point.y = args.point.y.toLocaleString('en-ZA', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
}

function onAxisLabelRender(args: IAxisLabelRenderEventArgs): void {
    if (args.axis.name === 'primaryYAxis') {
        const rawValue = parseFloat(args.text.replace(/[^\d.]/g, ''));
        args.text = formatCurrencyAbbreviated(rawValue);
    }
}

function onTooltipRender(args: ITooltipRenderEventArgs): void {
    const yValue =
        typeof args.point?.y === 'number'
            ? args.point.y
            : 0;

    const formattedY =
        decimalPipe.transform(yValue, '1.2-2', 'en-ZA') ?? '0.00';

    const point: any = args.point;

    const rawX =
        point?.x ??
        point?.xValue ??
        '';

    let formattedX = '';

    // REAL DATE OBJECT
    if (rawX instanceof Date) {
        formattedX =
            datePipe.transform(
                rawX,
                'dd MMM yyyy',
                undefined,
                'en-ZA',
            ) ?? '';
    }

    // yyyy-MM-dd
    else if (
        typeof rawX === 'string' &&
        /^\d{4}-\d{2}-\d{2}$/.test(rawX)
    ) {
        const [year, month, day] = rawX.split('-').map(Number);

        const parsedDate = new Date(year, month - 1, day);

        formattedX =
            datePipe.transform(
                parsedDate,
                'dd MMM yyyy',
                undefined,
                'en-ZA',
            ) ?? rawX;
    }

    // yyyy-MM
    else if (
        typeof rawX === 'string' &&
        /^\d{4}-\d{2}$/.test(rawX)
    ) {
        const [year, month] = rawX.split('-').map(Number);

        const parsedDate = new Date(year, month - 1, 1);

        formattedX =
            datePipe.transform(
                parsedDate,
                'MMM yyyy',
                undefined,
                'en-ZA',
            ) ?? rawX;
    }

    // Week 1 / category labels
    else {
        formattedX = String(rawX);
    }

    args.text = `${formattedX} : R ${formattedY}`;
}

export function getSvdIntervalType(viewDateAs: SalesDisplayMode): string {
    if (viewDateAs === SalesDisplayMode.daily) {
        return 'Days';
    } else if (viewDateAs === SalesDisplayMode.monthly) {
        return 'Months'
    } else if (viewDateAs === SalesDisplayMode.yearly) {
        return 'Years'
    } else {
        return ''; // View as weekly, no specific interval type needed
    }
}

export function getSvdLabelFormat(viewDateAs: SalesDisplayMode): string {
    if (viewDateAs === SalesDisplayMode.daily) {
        return 'd-MMM';
    } else if (viewDateAs === SalesDisplayMode.monthly) {
        return 'MMM y';
    } else if (viewDateAs === SalesDisplayMode.yearly) {
        return 'y';
    } else {
        return ''; // View as weekly,  no specific label format needed
    }
}

export const ChartUtils = {
    onTextRender,
    onAccumulationChartTextRender,
    onAxisLabelRender,
    onTooltipRender,
    getSvdIntervalType,
    getSvdLabelFormat
};
